import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "border",
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  viewbox: "0 0 19 19",
  fill: "none"
}
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("circle", {
      cx: "9.5",
      cy: "9.5",
      r: "9.5",
      fill: $setup.props.color
    }, null, 8, _hoisted_2),
    _cache[0] || (_cache[0] = _createStaticVNode("<circle cx=\"13\" cy=\"6\" r=\"2\" fill=\"white\" data-v-e0f2062e></circle><g opacity=\"0.48\" data-v-e0f2062e><mask id=\"path-3-inside-1_24_299\" fill=\"white\" data-v-e0f2062e><path d=\"M1 10C1 5.58172 4.58172 2 9 2C13.4183 2 17 5.58172 17 10C17 14.4183 13.4183 18 9 18C4.58172 18 1 14.4183 1 10Z\" data-v-e0f2062e></path></mask><path d=\"M1 2H17H1ZM17 10.5C17 15.1944 13.1944 19 8.5 19C3.80558 19 0 15.1944 0 10.5L2 10C2 13.866 5.13401 17 9 17C13.4183 17 17 13.866 17 10V10.5ZM8.5 19C3.80558 19 0 15.1944 0 10.5C0 5.80558 3.80558 2 8.5 2H9C5.13401 2 2 5.58172 2 10C2 13.866 5.13401 17 9 17L8.5 19ZM17 2V18V2Z\" fill=\"white\" mask=\"url(#path-3-inside-1_24_299)\" data-v-e0f2062e></path></g>", 2))
  ]))
}